import * as React from "react";
import {
  LoaderFunctionArgs,
  redirect,
  useOutletContext,
} from "react-router-dom";
import { NovelistContent } from "./novelist/NovelistContent";
import { Divider } from "@mui/material";
import { SyndeticsRelatedContent } from "./syndetics/SyndeticsRelatedContent";
import { getRedirectToDefaultTab } from "../resource/ResourcePage";
import {
  getResourceByHostRecordId,
  getResourceById,
} from "../resource/getResourceById";
import { LocationConfigurationHolder } from "../../LocationConfiguration";
import { SyndeticsConfigHolder } from "../../SyndeticsConfig";
import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";

export async function relatedGuard({ params }: LoaderFunctionArgs) {
  const titleId = params.titleId;
  const hostRecordId = params.hostRecordId;
  const data = !!titleId
    ? await getResourceById(titleId)
    : await getResourceByHostRecordId(hostRecordId);
  const basePath = !!titleId
    ? `/resource/${titleId}`
    : `/hostrecord/${hostRecordId}`;

  if (data.rtype !== 1) {
    return redirect(`${basePath}/details`);
  }
  const locationConfiguration =
    await LocationConfigurationHolder.fetchLocationConfiguration();
  const { useNoveList, displaySettings } =
    locationConfiguration.pacSettings ?? {};

  const { hasRelatedTabEnrichments } = await SyndeticsConfigHolder.getData();

  if (!hasRelatedTabEnrichments && !useNoveList) {
    const defaultTabPath = await getRedirectToDefaultTab(data);
    return redirect(`${basePath}/${defaultTabPath}`);
  }

  return null;
}

export const RelatedPage: React.FC = () => {
  const resource = useOutletContext<ResourceDWR>();

  return (
    <>
      <NovelistContent resource={resource}></NovelistContent>
      <Divider />
      <SyndeticsRelatedContent resource={resource} />
    </>
  );
};
